import { Directive } from '@angular/core';
import { BrnDialogDescription } from '@spartan-ng/brain/dialog';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
    host: { 'data-slot': 'dialog-description' },
    hostDirectives: [BrnDialogDescription],
    selector: '[hlmDialogDescription]',
})
export class HlmDialogDescription {
    constructor() {
        classes(
            () =>
                'text-muted-foreground *:[a]:hover:text-foreground text-sm *:[a]:underline *:[a]:underline-offset-3'
        );
    }
}
